<template>
  <div class="pageStyle" @click="showCompanyNameList = false">
    <div>
      <div class="header">
        <div>请填写您信息</div>
        <div>信息提交后会有专员联系您</div>
      </div>
      <div class="content">
        <div class="input-form">
          <!-- 企业名称 -->
          <div class="item companyNameInput">
            <div class="title">
              <span><s></s></span>
              <span>企业名称</span>
            </div>
            <div class="input">
              <van-field
                v-model="form.companyName"
                @input="onCompanyNameChange"
                @clear="clearCompanyName"
                clearable
                placeholder="请填写企业名称"
              />
              <div class="companyNameList" v-show="showCompanyNameList">
                <span
                  @click="choiceCompanyName(item)"
                  v-for="(item, index) in companyNameList"
                  :key="index"
                  >{{ item }}</span
                >
              </div>
            </div>
          </div>

          <!-- 联系人姓名 -->
          <div class="item">
            <div class="title">
              <span><s></s></span>
              <span>联系人姓名</span>
            </div>
            <div class="input">
              <van-field
                v-model="form.applyName"
                placeholder="请填写联系人姓名"
              />
            </div>
          </div>

          <!-- 联系人电话 -->
          <div class="item">
            <div class="title">
              <span><s></s></span>
              <span>联系人电话</span>
            </div>

            <div class="input">
              <van-field
                type="digit"
                v-model="form.phone"
                placeholder="请填写联系人电话"
                maxlength="11"
              />
            </div>
          </div>

          <!-- 企业开票金额（万） -->
          <div class="item">
            <div class="title">
              <span><s></s></span>
              <span>企业开票金额（万）</span>
            </div>

            <div class="input">
              <van-field
                type="number"
                v-model="form.invoiceAmt"
                placeholder="请填写企业开票金额（万）"
              />
            </div>
          </div>

          <!-- 企业纳税金额（万） -->
          <div class="item">
            <div class="title">
              <span><s></s></span>
              <span>企业纳税金额（万）</span>
            </div>

            <div class="input">
              <van-field
                type="number"
                v-model="form.taxAmt"
                placeholder="请填写企业纳税金额（万）"
              />
            </div>
          </div>
          <div class="item btn">
            <van-button :loading="submitLoading" @click="submit()"
              >提交</van-button
            >
          </div>
        </div>
        <div class="bg">
          <div></div>
        </div>
      </div>

      <div class="foot"></div>
    </div>
    <!-- 选择城市弹窗 -->
    <van-popup v-model="selectArea" position="bottom">
      <van-area
        :columns-num="2"
        title="选择城市"
        :area-list="areaList"
        @confirm="confirmArea"
        @cancel="selectArea = !selectArea"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  xcCompanySearch,
  xcCompanySearchCus,
  xcCompanyInfo,
} from "@/api/xcCustomer";
import { getWx } from "@/utils/wxJsSdk.js";
import { xcLeadInfoNL } from "@/api/applyPage.js";
import Vue from "vue";
import {
  Notify,
  Empty,
  Button,
  Field,
  Toast,
  Popup,
  Area,
  DatetimePicker,
  RadioGroup,
  Radio,
} from "vant";
import { areaList } from "@vant/area-data";
import { getDepNameByDomain } from "@/utils/index";
import { xcDepConfig } from "@/api/depConfig.js";
import { getCurrentChannelInfo } from "@/api/login.js";
Vue.use(Button);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Toast);
Vue.use(DatetimePicker);
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
  created() {
    this.getDepConfig();
    this.getQuery();
  },
  data() {
    // 过滤areaList数据，只保留湖南省及其下面的城市

    return {
      form: {
        invoiceAmt: "",
        taxAmt: "",
        intentionBank: "",
        area: "",
        companyName: "",
        applyName: "",
        phone: "",
        referrer: "",
        depName: "",
        association: "",
        productId: "",
      },
      depNameForShow: "",
      // 提交的loading
      submitLoading: false,
      // 是否显示企业名称列表
      showCompanyNameList: false,
      // 企业名称快捷选择区域
      companyNameList: [],
      depName: "",
      depConfig: {},
      // 选择城市弹窗
      selectArea: false,
      // 选择城市 城市数据（仅湖南省）
      areaList: this.getHuNanAreaData(),
    };
  },
  methods: {
    getHuNanAreaData() {
      const hunanCode = "430000";
      const filteredAreaList = {
        province_list: { [hunanCode]: areaList.province_list[hunanCode] },
        city_list: {},
        county_list: {},
      };

      // 过滤湖南省的城市
      for (const key in areaList.city_list) {
        if (key.startsWith("43")) {
          filteredAreaList.city_list[key] = areaList.city_list[key];
        }
      }

      // 过滤湖南省的区县（虽然当前只显示两级，但为了数据完整性保留）
      for (const key in areaList.county_list) {
        if (key.startsWith("43")) {
          filteredAreaList.county_list[key] = areaList.county_list[key];
        }
      }
      console.log("filteredAreaList", filteredAreaList);
      return filteredAreaList;
    },
    // 确认城市 确认
    confirmArea(areas) {
      this.form.area = areas[1].name;
      this.selectArea = !this.selectArea;
    },
    getQuery() {
      this.queryMsg = this.$route.query;
      // 有产品id的话，则赋值
      if (this.queryMsg.productId) {
        this.form.productId = this.queryMsg.productId;
      }
    },
    getDepConfig() {
      this.depName = getDepNameByDomain();
      xcDepConfig(this.depName).then((res) => {
        // console.log("res", res);
        this.depConfig = res;
        this.form.depName = res.depName;
        // 如果当前不是总协会，则赋值当前协会名称
        // 如果是总协会，则用户可以自己填，不需要赋值
        if (res.depName != "jf") {
          this.form.association = res.depCompanyName;
        }
        // 所属协会
        // this.form.association = res.depCompanyName;
      });
    },
    onCompanyNameChange(e) {
      // 例如：珠海市香
      if (e.length > 3) {
        xcCompanySearchCus(e).then((res) => {
          if (res && res[0]) {
            this.companyNameList = res;
            this.showCompanyNameList = true;
          }
        });
      }
    },
    clearCompanyName() {
      this.showCompanyNameList = false;
      this.companyNameList = [];
    },
    // 在企业名称列表里选择企业
    choiceCompanyName(e) {
      this.form.companyName = e;
      // Toast.loading({
      //   message: "加载中...",
      //   forbidClick: true,
      //   overlay: true,
      //   duration: 0,
      // });
      // xcCompanyInfo(e)
      //   .then((res) => {
      //     this.form.creditCode = res.creditCode;
      //     this.form.companyName = res.name;
      //     console.log("res", res);
      //     Toast.clear();
      //   })
      //   .catch((err) => {
      //     Toast.clear();
      //     console.log("err", err);
      //   });
    },
    // 提交信息
    submit() {
      // 校验填写内容
      if (this.toCheck()) {
        for (let key in this.form) {
          if (!this.form[key]) delete this.form[key];
        }
        this.submitLoading = true;
        xcLeadInfoNL(this.form)
          .then((res) => {
            this.submitLoading = false;
            this.form.companyName = "";
            this.form.applyName = "";
            this.form.phone = "";
            this.form.invoiceAmt = "";
            this.form.taxAmt = "";
            this.form.intentionBank = "";
            this.form.area = "";
            this.form.referrer = "";
            Toast.success("信息提交成功");
          })
          .catch((err) => {
            this.submitLoading = false;
            // Toast.fail("信息提交失败");
          });
      }
    },
    // 检查填写
    toCheck() {
      if (!this.form.companyName) {
        Notify({ type: "primary", message: "请填写企业名称" });
        return false;
      }
      if (!this.form.applyName) {
        Notify({ type: "primary", message: "请填写联系人姓名" });
        return false;
      }
      if (!this.form.phone) {
        Notify({ type: "primary", message: "请填写联系人电话" });
        return false;
      }
      if (!this.form.invoiceAmt) {
        Notify({ type: "primary", message: "请填写企业开票金额（万）" });
        return false;
      }
      if (!this.form.taxAmt) {
        Notify({ type: "primary", message: "请填写企业纳税金额（万）" });
        return false;
      }
      return true;
    },
    // getShareTxt() {
    //   let desc = "点击立即申请";
    //   let that = this;
    //   let url = window.location.href;
    //   getWx(this.depName).then((res) => {
    //     window.wx.updateAppMessageShareData({
    //       title: "车贷申请", // 分享标题
    //       desc: desc, // 分享描述
    //       link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       imgUrl:
    //         "https://static.xchengtech.cn/4a6254f9d27042ddabb8c7d8c766b9bc.png", // 分享图标
    //       success: function (res) {
    //         console.log("res", res);
    //         //afterShare();
    //       },
    //     });
    //   });
    // },
  },
};
</script>

<style scoped src="./index.css"></style>


// WEBPACK FOOTER //
// src/view/applyPage/leadInfoForXrr/leadInfo.vue